import React from "react";

export default function Footer() {
  return (
    <>
      <footer className="d-flex justify-content-between align-items-center container">
        <div className="d-flex">
          <p className="me-1">© {new Date().getFullYear()}</p>
          <p className="m-0">
            Made with{" "}
            <span role="img" aria-label="love">
              ❤️
            </span>{" "}
            by{" "}
            <a href="https://www.linkedin.com/in/abdalaziz-mohamed-58a943248/" target="_blank" rel="noreferrer">
              <strong>Abdalaziz </strong>
            </a>{" "}
          </p>
        </div>
        <div>
          <ul className="d-flex m-0 p-0 list-unstyled">
            <li className="me-3">
              <a href="https://experience-mark.net/" target="_blank" rel="noreferrer">
                الرئيسية
              </a>
            </li>
            <li className="me-3">
              <a href="https://experience-mark.net/about/" target="_blank" rel="noreferrer">
                نبذة عنا
              </a>
            </li>
            <li className="me-3">
              <a href="https://experience-mark.net/services/" target="_blank" rel="noreferrer">
                خدماتنا
              </a>
            </li>
            <li>
              <a href="https://experience-mark.net/contact-us/" target="_blank" rel="noreferrer">
                اتصل بنا
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </>
  );
}
